import {
  put,
  fork,
  takeLatest
} from 'redux-saga/effects';
import {NORMALIZE_DATA} from '../../dataProvider/dataProvider';
import {SET_DATA} from './equipment';

// WATCHERS
export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}

// WORKERS
export function* normalizeWorker({key, data, meta}) {
  if (key !== 'equipment') {
    return;
  }

  yield put({
    type: SET_DATA,
    payload: {
      ...meta,
      equipment: data.equipments
    }
  });
}

export default function* equipmentSagas() {
  yield [
    fork(normalizeWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/equipment/equipmentSagas.js
 **/